// extracted by mini-css-extract-plugin
module.exports = {"header":"header__X4wq_","message":"message__3mXRA","button-wrapper":"button-wrapper__1ZB4E"};